<mcrit-gestio-calendar-metadata
  *ngFor="let calendar of availableCalendars;"
  (change)="calendarChange($event)"
  [calendarData]="calendar">
</mcrit-gestio-calendar-metadata>
<button mat-fab class="floating-button">
    <mat-icon color="primary" style="font-size:24px">add</mat-icon>
</button>
